

export class SummaryGridDataObjectModel { 
    [key: string] : any;
    size ?: string;
    quantity ?: number;
    html ?: any;
}
